import { useRecoilState } from 'recoil';

import { financeState } from '@/states/finance/finance.states';


export function useFinance() {
  const [selectedFinance, setSelectedFinance] = useRecoilState(financeState);

  return {
    selectedFinance,
    setSelectedFinance,
  };
}